import styled from 'styled-components';

import Card from 'components/insights/layout/Card';

const TableTitle = styled(Card.Title)`
  margin: 0;
`;

export default TableTitle;
